/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/AddPageOptions.yaml
import { DocumentStraighteningParameters } from '../core/document_scanner/DocumentEnhancerTypes';
import { ParametricFilter } from '../core/image_processing/ParametricFilters';
/**
Options for creating a document from images.
*/
export class AddPageOptions {
    /** @param source {@displayType `DeepPartial<AddPageOptions>`} */
    constructor(source = {}) {
        /**
          The list of filters applied to the page. If not specified, no filters are applied.
          */
        this.filters = null;
        /**
          The index at which the new page will be inserted. If not provided, the page will be added at the end of the document.
          */
        this.index = null;
        /**
          Recognizes documents on created page.
          
          Default is true
          */
        this.documentDetection = true;
        /**
          The parameters to use for straightening.
          */
        this.straighteningParameters = new DocumentStraighteningParameters({});
        if (source.filters !== undefined) {
            this.filters =
                source.filters != null
                    ? source.filters.map((it) => {
                        return ParametricFilter.from(it);
                    })
                    : null;
        }
        if (source.index !== undefined) {
            this.index = source.index != null ? source.index : null;
        }
        if (source.documentDetection !== undefined) {
            this.documentDetection = source.documentDetection;
        }
        if (source.straighteningParameters !== undefined) {
            this.straighteningParameters = new DocumentStraighteningParameters(source.straighteningParameters);
        }
    }
}
//# sourceMappingURL=AddPageOptions.js.map